import { useContext, useEffect, useState } from "react";
import useLocalStorage from "../../Utility/useLocalStorage";
import Repo from "../../Utility/Repo";
import { Link } from "react-router-dom";
import { TokenContext } from "../../Components/TokenContext";
import CardHome from "../../Components/CardHome";

const cards = [
  {
    id: 1,
    titolo: "INTERVENTI",
    descrizione:
      "Potrai visualizzare tutti gli interventi disponibili e filtrarli per categoria",
    badge: 0,
    link: "/lista_interventi",
  },
  {
    id: 2,
    titolo: "UTENTI",
    descrizione:
      "Potrai visualizzare tutti gli utenti presenti nella  piattaforma, inserirne nuovi e caricare per loro l'Isee",
    badge: 0,
    link: "/lista_utenti",
  },
];

function HomeExecutive(props) {
  const [cardsState, setCardsState] = useState([]);
  const apiToken = useContext(TokenContext);
  //
  //setCardsState(cards);

  return (
    <>
      <h1>Pannello operatore PUA</h1>
      <div className="clearfix col-lg-8 py-lg-2">
        <p>
          Riepilogo delle principali funzioni di{" "}
          <strong>Semplícita Ambiti Territoriali Sociali</strong>
        </p>
      </div>
      <div className="row">{cards.map(CardHome)}</div>
    </>
  );
}

export default HomeExecutive;
